import SEOHead, { SITE_URL } from '@/components/base/SEOHead';
import ArticleLayout from '../components/ArticleLayout';
import { seoArticles } from '@/mocks/articleData';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const article = seoArticles[6];

const bulkJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    author: { '@type': 'Person', name: 'Mulebuy Spreadsheet Research Team' },
    datePublished: '2026-06-01',
    dateModified: '2026-06-22',
    image: article.imageUrl,
    description: article.description,
    url: `${SITE_URL}/${article.slug}`,
    publisher: {
      '@type': 'Organization',
      name: 'Mulebuy Spreadsheet Hub',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_URL },
      { '@type': 'ListItem', position: 2, name: article.title, item: `${SITE_URL}/${article.slug}` },
    ],
  },
  ...(article.faqs.length > 0
    ? [
        {
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: article.faqs.map((faq) => ({
            '@type': 'Question',
            name: faq.question,
            acceptedAnswer: { '@type': 'Answer', text: faq.answer },
          })),
        },
      ]
    : []),
];

export default function ArticleBulkOrdering() {
  return (
    <div className="min-h-screen bg-background-50">
      <SEOHead
        title={article.title}
        description={article.description}
        canonicalPath={`/${article.slug}`}
        ogType="article"
        ogImage={article.imageUrl}
        jsonLd={bulkJsonLd}
      />
      <Navbar />
      <ArticleLayout article={article} />
      <Footer />
    </div>
  );
}